export default __webpack_public_path__ + "87fe6a95b9a09c4a6065990e979ee3e7.png";